export const extractFunctions = (text: string) => {
	const functions = text.match(
		/(\s)?([a-zA-Z]+)\(((.*))?\)/gm
	);
	
	return (
		functions?.map((item) => {
			
			return {
				replace: item.trim(),
				functionName:
                /(\s)?([a-zA-Z]+)\(((.*))?\)/gm.exec(item)?.[2] ?? '',
				params: /(\s)?([a-zA-Z]+)\(((.*))?\)/gm.exec(item)
					?.[4]
					?.split(',')
					.map((item) => 
						item?.replace(/['"]/g, '')
							.trim()
							.replace(/{\/{comma}\/}/g, ',')
							.replace(/{\/{quote}\/}/g, '"')
					) ?? [],
			};
		}) ?? []
	);
};




 